import React from 'react';
import PropTypes from 'prop-types';
import { PadContainer } from 'smartsuite-ui';
import SelectorContainer from '../../SelectorContainer';
import { getValueStyles } from '../../valueDisplay/gaugeValueDisplay/gaugeValueDisplayUtils';
import {
    getFormattedGaugeValue,
    getFormattedThresholdValue,
} from '../../utils/dataFormatUtils';
import GaugeTicketValue from './GaugeTicketValue';
import useLink from '../../../../shared/hooks/linkHooks';

// eslint-disable-next-line complexity
export default function GaugeTicket(props) {
    const linkUri = useLink(
        props.configuration.linkConfig,
        props.metricRequest,
        props.values
    ); // todo

    const threshold =
        props.thresholds.find((x) => x.itemId === props.dataLabel) ??
        props.thresholds.find((x) => !x.itemId);

    const formattedThresholdValue = getFormattedThresholdValue(
        threshold,
        props.formatter,
        props.configuration.suffix,
        props.configuration.timeFormat
    );

    function renderSingleValueGaugeTicket() {
        return (
            <GaugeTicketValue
                label={props.configuration.label}
                dataLabel={props.dataLabel}
                metricRequest={props.metricRequest}
                openLinksInNewTab={props.openLinksInNewTab}
                title={formattedThresholdValue}
                value={getFormattedGaugeValue(
                    props.values[props.metricRequest.metrics[0]],
                    props.formatter,
                    props.configuration.suffix,
                    props.configuration.timeFormat
                )}
                linkConfig={props.configuration.linkConfig}
                valueStyles={getValueStyles(
                    props.values[props.metricRequest.metrics[0]],
                    threshold
                )}
            />
        );
    }

    function renderMultiValueGaugeTicket() {
        const widthStyle = `calc(100% / ${props.columns.length})`;
        return props.columns.map((column) => (
            <GaugeTicketValue
                label={column.label}
                dataLabel={props.dataLabel}
                metricRequest={props.metricRequest}
                openLinksInNewTab={
                    props.columns.openLinksInNewTab ?? props.openLinksInNewTab
                }
                title={formattedThresholdValue}
                value={getFormattedGaugeValue(
                    props.values[column.dataKey],
                    props.formatter,
                    props.configuration.suffix,
                    props.configuration.timeFormat
                )}
                key={column.dataKey}
                linkConfig={column.linkConfig}
                valueStyles={getValueStyles(
                    props.values[column.dataKey],
                    threshold
                )}
                widthStyle={widthStyle}
            />
        ));
    }

    if (props.configuration.linkConfig) {
        return (
            <div className="gauge-ticket__columns">
                <a
                    href={linkUri}
                    target={props.openLinksInNewTab ? '_blank' : ''}
                    rel="noreferrer"
                    style={{ width: `calc(${props.titleWidth})` }}
                >
                    {props.title}
                </a>
                <PadContainer cssClassModifiers={['pad-medium']} />
                <div className="gauge-ticket__chart">
                    {props.columns
                        ? renderMultiValueGaugeTicket()
                        : renderSingleValueGaugeTicket()}
                </div>
            </div>
        );
    }
    return (
        <SelectorContainer
            isActive={props.isActive}
            isSelectable={props.isSelectable}
            onSelectorClick={props.onSelectorClick}
            onSelectorRemoveClick={props.onSelectorRemoveClick}
            title={props.title}
            titleWidth={props.titleWidth}
        >
            <div className="gauge-ticket__chart">
                {props.columns
                    ? renderMultiValueGaugeTicket(props)
                    : renderSingleValueGaugeTicket(props)}
            </div>
        </SelectorContainer>
    );
}

GaugeTicket.propTypes = {
    configuration: PropTypes.instanceOf(Object),
    columns: PropTypes.instanceOf(Array),
    dataLabel: PropTypes.string.isRequired,
    formatter: PropTypes.func.isRequired,
    metricRequest: PropTypes.instanceOf(Object).isRequired,
    isActive: PropTypes.bool.isRequired,
    isSelectable: PropTypes.bool.isRequired,
    onSelectorClick: PropTypes.func.isRequired,
    onSelectorRemoveClick: PropTypes.func.isRequired,
    openLinksInNewTab: PropTypes.bool.isRequired,
    thresholds: PropTypes.instanceOf(Array).isRequired,
    title: PropTypes.string.isRequired,
    titleWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    values: PropTypes.instanceOf(Object),
};
